import { useChannelContext } from "client/components/channel"

import { useActiveSaleHighlights } from "./useActiveSale"

export function useFeaturedProduct() {
  const { channelId } = useChannelContext()
  const [activeSale] = useActiveSaleHighlights(channelId)
  const featuredProduct = activeSale?.products?.find((product) => {
    return product?.id === activeSale?.featuredProductId
  })

  return {
    product: featuredProduct ?? null,
  }
}
